import { useCallback, useContext } from 'react';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import { GridDate as GridDateBase } from 'components/Grid';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';

interface CalibrationGridDateProps {
  cell: ICell;
  minDate: string;
}

const CalibrationGridDate = ({ cell, minDate }: CalibrationGridDateProps) => {
  const { onCellsChanged } = useContext(FeaturedSpreadsheetContext);

  const handleOnChange = useCallback(
    (newValue: string, cell: ICell) => {
      onCellsChanged([{ cell, value: newValue }]);
    },
    [onCellsChanged]
  );

  const { value, readOnly, disabled } = cell;

  const cellValue = value as string;

  return (
    <GridDateBase
      cell={cell}
      value={cellValue}
      readOnly={readOnly}
      disabled={disabled}
      onCellsChanged={handleOnChange}
      minDate={minDate}
    />
  );
};

export default CalibrationGridDate;
